import Slider from '@react-native-community/slider';
import React, { useState } from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import { AudioPlayerProps } from '../type';

/**
 *
 * @param seconds - seconds
 * @returns - time string in the format of "hh:mm:ss", ex: "01:02:03", "02:03", "00:03"
 */
const getTimeString = (seconds: number) => {
  const remainingHours = Math.floor(seconds / 3600);
  const remainingMinutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  if (remainingHours > 0) {
    return `${remainingHours.toString().padStart(2, '0')}:${remainingMinutes
      .toString()
      .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }
  if (remainingMinutes > 0) {
    return `${remainingMinutes.toString().padStart(2, '0')}:${remainingSeconds
      .toString()
      .padStart(2, '0')}`;
  }
  return `00:${remainingSeconds.toString().padStart(2, '0')}`;
};

type Props = AudioPlayerProps & {
  onDownload: () => void;
  onPlayPause: () => void;
  onSeek: (value: number) => void;
  onSeekBackward: () => void;
  onSeekForward: () => void;
  duration: number; // seconds
  title: string;
  time: number; // seconds
  isPlaying: boolean;
};
export const Player: React.FC<Props> = (props) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const {
    onDownload,
    onPlayPause,
    duration,
    onSeek,
    onSeekBackward,
    onSeekForward,
    title,
    time,
    isPlaying,
  } = props;
  return (
    <View
      style={{
        padding: 20,
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <Text
        style={{
          fontSize: 16,
          marginBottom: 10,
        }}
      >
        {title}
      </Text>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Text
          style={{
            fontSize: 11,
            marginHorizontal: 4,
          }}
        >
          {getTimeString(time)}
        </Text>
        <Slider
          style={{ flex: 1, height: 40 }}
          minimumValue={0}
          maximumValue={duration}
          value={time}
          onSlidingComplete={onSeek}
        />
        <Text
          style={{
            fontSize: 11,
            marginHorizontal: 4,
          }}
        >
          {getTimeString(duration)}
        </Text>
        <TouchableOpacity
          style={{
            marginLeft: 8,
            padding: 8,
          }}
          onPress={() => setMenuVisible(!menuVisible)}
          accessibilityRole="button"
          accessibilityLabel="More options"
        >
          <Text
            style={{
              fontSize: 20,
            }}
          >
            ⋮
          </Text>
        </TouchableOpacity>
      </View>
      {menuVisible ? (
        <View
          style={{
            position: 'absolute',
            right: 20,
            top: 70,
            backgroundColor: '#ffffff',
            borderRadius: 6,
            shadowColor: '#000',
            shadowOpacity: 0.1,
            shadowRadius: 8,
            shadowOffset: { width: 0, height: 2 },
            elevation: 3,
          }}
        >
          <TouchableOpacity
            style={{
              paddingVertical: 10,
              paddingHorizontal: 14,
              minWidth: 140,
            }}
            onPress={() => {
              // eslint-disable-next-line no-console
              console.log('=== AudioPlayer: Download pressed');
              setMenuVisible(false);
              onDownload();
            }}
          >
            <Text
              style={{
                fontSize: 14,
              }}
            >
              Download
            </Text>
          </TouchableOpacity>
        </View>
      ) : null}
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-around',
          width: '80%',
          marginVertical: 10,
        }}
      >
        <TouchableOpacity onPress={onSeekBackward}>
          <Icon name={'replay-5'} size={28} color="#000" />
        </TouchableOpacity>
        <TouchableOpacity onPress={onPlayPause}>
          <Icon
            name={isPlaying ? 'pause-circle-outline' : 'play-circle-outline'}
            size={28}
            color="#000"
          />
        </TouchableOpacity>
        <TouchableOpacity onPress={onSeekForward}>
          <Icon name={'forward-5'} size={28} color="#000" />
        </TouchableOpacity>
      </View>
    </View>
  );
};
